import moment from 'moment'

import LumifyResource from './LumifyResource'

export const SAML_URL = '/saml/login'
export const AUTH_INFO = '/admin/secured/userInformation'
export class AuthInfo extends LumifyResource {
  first_name = ''
  last_name = ''
  email = ''
  role = 'ROLE_NONE'

  pk() {
    return AUTH_INFO
  }

  static authInfoShape() {
    // Endpoint-style function instead of legacy shape object
    const endpoint = async () => {
      try {
        return await this.fetch('get', AUTH_INFO)
      } catch (err) {
        if (err.status === 403) {
          return {
            first_name: '',
            last_name: '',
            email: '',
            role: 'ROLE_NONE'
          }
        }
        throw err
      }
    }
    endpoint.type = 'read'
    endpoint.schema = this
    endpoint.getFetchKey = () => AUTH_INFO
    endpoint.key = () => AUTH_INFO
    endpoint.options = { invalidIfStale: true }
    endpoint.fetch = endpoint
    return endpoint
  }

  static get key() {
    return AUTH_INFO
  }
  static url = () => AUTH_INFO
}

export const AUTH_LOGOUT = '/admin/secured/logoff'
export class AuthLogout extends LumifyResource {
  static logoutShape() {
    const endpoint = () => this.fetch('get', AUTH_LOGOUT)
    endpoint.type = 'read'
    endpoint.schema = false
    endpoint.getFetchKey = () => AUTH_LOGOUT
    endpoint.key = () => AUTH_LOGOUT
    endpoint.options = {}
    endpoint.fetch = endpoint
    return endpoint
  }

  pk() {
    return AUTH_LOGOUT
  }

  static get key() {
    return AUTH_LOGOUT
  }
  static url = () => AUTH_LOGOUT
}

export const CHECK_LOGIN = '/admin/secured/userLoggedIn'
export class CheckLogin extends LumifyResource {
  expires = moment().add(-15, 'seconds').unix()

  static checkLoginShape() {
    const endpoint = async () => {
      // Use LumifyResource.fetchOptionsPlugin to include CSRF token and credentials
      const fetchOptions = LumifyResource.fetchOptionsPlugin({
        headers: {
          'Content-Type': 'application/json'
        }
      })
      const response = await fetch(CHECK_LOGIN, fetchOptions)
      if (!response.ok) {
        // Return expired timestamp if not authenticated
        console.log('userLoggedIn check failed with status:', response.status)
        return {
          expires: moment().add(-1, 'hours').unix() // Return expired timestamp
        }
      }
      const text = await response.text()
      return {
        expires: moment().add(text, 'seconds').add(-15, 'seconds').unix()
      }
    }
    endpoint.type = 'read'
    endpoint.schema = this
    endpoint.getFetchKey = () => CHECK_LOGIN
    endpoint.key = () => CHECK_LOGIN
    endpoint.pollFrequency = 300000 // every 5 minutes - required at top level for Rest Hooks v7+
    endpoint.options = {
      invalidIfStale: true,
      pollFrequency: 300000 // every 5 minutes
    }
    endpoint.fetch = endpoint
    return endpoint
  }

  pk() {
    return CHECK_LOGIN
  }

  static urlRoot = CHECK_LOGIN
}

export const FORCE_LOGIN = '/admin/secured/logUser'
export class ForceLogin extends LumifyResource {
  static forceLoginShape() {
    const endpoint = role => this.fetch('get', `${FORCE_LOGIN}?role=${role}`)
    endpoint.type = 'read'
    endpoint.schema = ''
    endpoint.getFetchKey = () => FORCE_LOGIN
    endpoint.key = () => FORCE_LOGIN
    endpoint.fetch = endpoint
    return endpoint
  }

  pk() {
    return FORCE_LOGIN
  }

  static urlRoot = FORCE_LOGIN
}

export const CHECK_PRODUCTION = '/admin/secured/isProduction'
export class CheckProduction extends LumifyResource {
  static checkProductionShape() {
    const endpoint = () => this.fetch('get', CHECK_PRODUCTION)
    endpoint.type = 'read'
    endpoint.schema = ''
    endpoint.getFetchKey = () => CHECK_PRODUCTION
    endpoint.key = () => CHECK_PRODUCTION
    endpoint.options = {}
    endpoint.fetch = endpoint
    return endpoint
  }

  pk() {
    return CHECK_PRODUCTION
  }

  static urlRoot = CHECK_PRODUCTION
}
